/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Audit_Logs_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "Use the filters to narrow by user, action type, or time period. This is the fastest way to investigate an issue or assemble records for a compliance report." |
*
* @param {Uno_Edu_Intro_Audit_Logs_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_audit_logs_chip2_answer = /** @type {((inputs?: Uno_Edu_Intro_Audit_Logs_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Audit_Logs_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwenden Sie die Filter, um nach Benutzer, Aktionstyp oder Zeitraum einzugrenzen. Das ist der schnellste Weg, ein Problem zu untersuchen oder Aufzeichnungen für einen Compliance-Bericht zusammenzustellen.")
	return /** @type {LocalizedString} */ ("Use the filters to narrow by user, action type, or time period. This is the fastest way to investigate an issue or assemble records for a compliance report.")
});